import Actions from '../../odata/actions';

const actions = new Actions('marketManOrder', 'marketManOrders');

export default actions;
